

















import Vue from 'vue'
import { mapActions } from 'vuex'
import { databases } from '../data-dummy/data-dummy'
import CreateCheckForm from '../components/CreateCheck/CreateCheckForm.vue'
import Tabs from '../components/Tabs/Tabs.vue'
import DatabasesStatus from '../components/DatabasesStatus/DatabasesStatus.vue'

export default Vue.extend({
  name: 'Checks',
  components: {
    CreateCheckForm,
    Tabs,
    DatabasesStatus
  },
  data: () => ({
    databases,
    showDatabasesStatuses: false
  }),
  methods: {
    ...mapActions('ui', { openSnackbar: 'openSnackbar' }),
    toogleDatabasesStatuses (): void {
      this.showDatabasesStatuses = !this.showDatabasesStatuses
    }
  }
})
